import { createFileRoute } from '@tanstack/react-router';
import { SupportHub } from '@/features/support/SupportHub';

/**
 * L'hub dell'assistenza: una voce di menu sola con tre schede — Scrivania (i ticket delle mie
 * gruppi), Da smistare (ciò che il server non ha saputo instradare), Argomenti (la configurazione).
 * La scheda sta nell'hash (`#da-smistare`), così le vecchie rotte e le notifiche atterrano su
 * quella giusta. Un ticket è un task con l'argomento valorizzato: la scrivania è una **vista** sui
 * task, e da lì si apre lo stesso drawer.
 */
export const Route = createFileRoute('/_app/support')({
  /* Il ticket aperto sta nell'URL: così il redirect dalla scheda del task lo ritrova. La scheda
     «Ticket» è già la prima (`SUPPORT_TABS[0]`), quindi non serve un hash esplicito. */
  validateSearch: (s: Record<string, unknown>): { ticket?: string } => ({
    ticket: typeof s.ticket === 'string' && s.ticket ? s.ticket : undefined,
  }),
  component: SupportRoute,
});

function SupportRoute() {
  const { ticket } = Route.useSearch();
  return <SupportHub openTicketId={ticket} />;
}
